import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export const PlusTrialBanner = ({ user }) => {
  if (!user || user.plus_access_source !== "free_trial" || user.plus_trial_days_remaining <= 0) return null;
  return (
    <div data-testid="plus-trial-banner" className="border-b border-[#C26B51]/40 bg-[#C26B51] px-4 py-2 text-center text-sm font-semibold text-white">
      <Link data-testid="plus-trial-banner-link" to="/plus" className="inline-flex items-center justify-center gap-2">
        <Sparkles size={15} /> You have {user.plus_trial_days_remaining} days left in your Bonsai Broker Plus trial.
      </Link>
    </div>
  );
};